import styled, { css } from 'styled-components';
import ReactTooltip from 'react-tooltip';

import Link from '../../_shared/components/Link';
import Icon from '../../_shared/components/Icon';

// TODO refactor css
const navStyles = {
  Secondary: css`
    position: fixed;
    top: 45px;
    z-index: 99;
    background-color: ${({ theme }) => theme.COLORS.BASE};
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
    padding-left: ${({ theme }) => theme.DIMENSIONS.LOGO_WIDTH};
    ${Link} {
      letter-spacing: 0.82px;
    }

    .active {
      color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    }

    .active-indicator {
      border-bottom: 3px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
      color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    }
  `
};

const navActiveStyles = {
  true: css`
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  `
};

export const StyledNav = styled.nav`
  width: 100%;
  overflow: hidden;
  position: relative;
  background-color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  color: ${({ theme }) => theme.COLORS.BASE};
  height: ${({ theme }) => theme.DIMENSIONS.HEADER_HEIGHT};
  display: flex;

  & > ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0 20px 0 0;
    height: 100%;
    align-items: center;
    white-space: nowrap;
    flex: 1 1 auto;
  }

  ${Link} {
    letter-spacing: 2.29px;
    color: inherit;
  }

  .active-indicator {
    position: absolute;
    bottom: 0;
    border-bottom: 3px solid ${({ theme }) => theme.COLORS.BASE};
  }
  ${props => navStyles[props.variant]}
`;

export const StyledDealerProfileContainer = styled.div`
  display: flex;
  margin-right: 70px;
  cursor: pointer;
`;

const StyledDealerName = styled.div`
  display: flex;
  flex: 0 0 auto;
  text-align: right;
  flex-direction: column;
  justify-content: center;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: 14px;
`;

StyledDealerName.UserName = styled.div`
  color: ${({ theme }) => theme.COLORS.BASE};
`;

StyledDealerName.CompanyName = styled.div`
  color: ${({ theme }) => theme.COLORS.NEUTRAL_20};
`;

StyledDealerName.CompanyBadgeContainer = styled.div`
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  background: ${({ theme }) => theme.COLORS.BASE};
  border-radius: 3px;
  padding-left: 6px;
  padding-right: 6px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
`;

StyledDealerName.CompanyBadge = styled.img`
  margin-right: 4px;
  height: 12px;
`;

StyledDealerName.CompanyNameWithBadge = styled.span`
  display: table;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
`;

StyledDealerName.FloatRight = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ReactTooltipStyled = styled(ReactTooltip)`
  padding: 6px 10px !important;
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL_30} !important;
  color: ${({ theme }) => theme.COLORS.BASE} !important;
`;

export { StyledDealerName };

export const StyledNavItem = styled.li`
  height: 100%;
  display: flex;
  align-items: center;

  ${props =>
    props['data-testid'].startsWith('navSecondary') &&
    navActiveStyles[props.active]}

  & + & {
    padding-left: 36px;
  }
`;

export const StyledDot = styled.span`
  font-size: 8px;
  padding-left: 4px;
  color: ${({ theme }) => theme.COLORS.PRIMARY};
`;

export const StyledDropdownIcon = styled(Icon).attrs({
  icon: 'TR5-Circle_Dropdown'
})`
  width: 24px;
  height: 45px;
  margin-left: 12px;
  cursor: pointer;
`;
